import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPkSk, IRole } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { UsersGroups } from 'projects/access-control/src/app/Domain/Entities/userGroups.interface';
import { Observable } from 'rxjs';
import { ApiService } from '../../Services/api.service';

@Injectable({
	providedIn: 'root',
})
export class UserService {
	constructor(private api: ApiService, private http: HttpClient) {}

	getUsers(paginationTo: number = 1): Observable<any> {
		return this.api.get<any>(`/users?_size=10&_page=${paginationTo}`);
	}

	searchUsers(url: string): Observable<any> {
		return this.api.get<any>(`/users/query${url}`);
	}

	createUsers(user: UsersGroups): Observable<any> {
		return this.api.post<any>(`/users`, user);
	}

	updateUsers(user: UsersGroups, ids: IPkSk): Observable<any> {
		return this.api.patch<any>(`/users/${ids.pk}/${ids.sk}`, user);
	}

	bulkDeleteGroup(users: string[]) {
		return this.api.delete(`/users`, { body: { users } });
	}
}
